import React from "react";
import { useMediaQuery } from "react-responsive";
import Link from "./link";
import { Remarkable } from "remarkable";
import { GlobalStore } from "../../stores/global";

const markdown = new Remarkable();

const JoinUsDesktop = ({ content }) => {
  const { currentCountryCode: countryCode } = GlobalStore.useState(c => c);
  const { title, subtitle, description, linkUrl, buttonText, list } = content;

  return (
    <div id="joinUsDesktop">
      <div className="wrap">
        <div className="joinUsLeft">
          <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
          <div className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
          {linkUrl && (
            <Link
              link={linkUrl.toLowerCase().replace(/:country/, countryCode.toLowerCase())}
              text={
                <>
                  <span>{buttonText}</span>
                </>
              }
              className="buttonLink sm"
            />
          )}
        </div>
        <div className="joinUsRight">
          <div className="joinUsRightTop">
            <div className="imgTop">{list && list[0] && <img alt="" src={list[0].image?.url} />}</div>
            <div className="title" dangerouslySetInnerHTML={{ __html: list && list[0] ? list[0].title : "" }} />
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: markdown.render(list && list[0] ? list[0].content : "") }}
            />
          </div>
          <div className="joinUsRightBottom">
            <div className="imgBottom">{list && list[1] && <img alt="" src={list[1].image?.url} />}</div>
            <div className="title" dangerouslySetInnerHTML={{ __html: list && list[1] ? list[1].title : "" }} />
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: markdown.render(list && list[1] ? list[1].content : "") }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const JoinUsMobile = ({ content }) => {
  const { currentCountryCode: countryCode } = GlobalStore.useState(c => c);
  const { title, subtitle, description, linkUrl, buttonTextMobile, list } = content;

  return (
    <div id="joinUsMobile">
      <div className="wrap">
        <div className="joinUsTop">
          <div className="joinUsHead">
            <div className="title" dangerouslySetInnerHTML={{ __html: title }} />
            <div className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          </div>
        </div>
        <div className="joinUsCenter">
          <div className="joinUsCenterTop">
            <div className="imgTop">{list && list[0] && <img alt="" src={list[0].image?.url} />}</div>
            <div className="title" dangerouslySetInnerHTML={{ __html: list && list[0] ? list[0].title : "" }} />
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: markdown.render(list && list[0] ? list[0].content : "") }}
            />
          </div>
          <div className="joinUsCenterBottom">
            <div className="imgBottom">{list && list[1] && <img alt="" src={list[1].image?.url} />}</div>
            <div className="title" dangerouslySetInnerHTML={{ __html: list && list[1] ? list[1].title : "" }} />
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: markdown.render(list && list[1] ? list[1].content : "") }}
            />
          </div>
        </div>
        <div className="joinUsBottom">
          <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
          {linkUrl && (
            <Link
              link={linkUrl.toLowerCase().replace(/:country/, countryCode.toLowerCase())}
              text={
                <>
                  <span>{buttonTextMobile}</span>
                </>
              }
              className="buttonLink sm"
            />
          )}
        </div>
      </div>
    </div>
  );
};

const JoinUs = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

  return isMobile ? <JoinUsMobile content={content} /> : <JoinUsDesktop content={content} />;
};

export default JoinUs;
